import { useSelector, useDispatch } from "react-redux";
import LiveDraggAbleComponentView from "./LiveDraggAbleComponentView";

export default function LiveTableCanvas() {
  const { tables } = useSelector((state) => state.table.table);

  return (
    <>
      <div className="">
        <div >
          {tables.filter((data) => data.is_visible !== false).map((data, index) => (
            <LiveDraggAbleComponentView key={index} data={data.table_size} id={data.id} fullDetails={data} />
          ))}
        </div>
        
      </div>
    </>
  );
}
